import NflightWeb from './NflightWeb';

export default NflightWeb;
